import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MarketingSection.html?raw';
import _StatefulSection from '../../../moreCore/UI/_StatefulSection/_StatefulSection';
import ExpandableSection from '../../../moreCore/UI/Container/ExpandableSection';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { ExpandableSectionMarkings } from "../../../moreCore/UI/Container/ExpandableSectionTypes";
import WeblinksEditor from '../../Weblinks/WeblinksEditor';
import lang from 'dojo/_base/lang';
import { HTWebfileLink, VtFile, WebfileLink, WeblinkEditorReponse } from "../../Weblinks/WeblinksEditorTypes";
import _GlobalSelectEntityDialogsMixin from '../../_loadingHelpers/_GlobalSelectEntityDialogsMixin';
import { SelectEntityDialogTypes } from "../../../moreCore/_loadingHelpers/SelectEntityDialog";
import FileWeblinksDlg from '../../Weblinks/FileWeblinksDlg';
import CheckBox from '../../../moreCore/UI/CheckBox/CheckBox';
import DateInput from '../../../moreCore/UI/DateInput/DateInput';

class MarketingSection extends compose(_StatefulSection, _GlobalSelectEntityDialogsMixin) {
    templateString: any = template;

    private weblinksExpander: MdsLax<InstanceType<typeof ExpandableSection>>;
    private weblinksTable: MdsLax<InstanceType<typeof StaticTable>>;
    private weblinksStore: MdsLax<InstanceType<typeof EntityStore<HTWebfileLink>>>;

    private publishInWebCheckbox: MdsLax<InstanceType<typeof CheckBox>>;
    private dateWebPublish: MdsLax<InstanceType<typeof DateInput>>;

    private rowConfig: StaticTable.RowConfig = {
        attributes: [
            "ref_webfile_link.description",
            "ref_webfile_link.ref_main_ht_webfile_link_category.ref_webfile_link_category.description",
            "ref_webfile_link.ref_web_placement.description",
            "ref_webfile_link.ClassPrintname"
        ],
        headings: [
            (this as any).translate("General_Description"),
            (this as any).translate("General_Label_WebFileCategory"),
            (this as any).translate("General_Label_WebPlacement"),
            (this as any).translate("General_Label_Type")
        ],
    }

    private tableLayout: StaticTable.Layout = {
        label: "weblinkTable",
        name: "weblinkTable",
        rows: [(this as any).rowConfig]
    }

    protected afterSetData(): void {
        super.afterSetData.apply(this, arguments as any);

        let weblinks = this.getAttributeValue("EL_webfile_vt_appointment");
        this.weblinksStore.setup(weblinks);

        if (weblinks.length > 0) this.weblinksExpander.setMarking(ExpandableSectionMarkings.hasContent);
    } 

    protected onDirtyChange(newState: boolean) {
        this.emit("change", this.getChangedData());
    }

    disableWebCheckbox(isEvent: boolean) {

        this.disableNode(this.publishInWebCheckbox, isEvent !== true);
        if (isEvent !== true) {
            this.setAttributeValue("is_to_publish_in_web", false, true);
        }
    }
    private onChanged_IsToPublishInWeb(attr, newValue, oldValue) {

        switch (attr) {
            case "is_to_publish_in_web":
                this.disableNode(this.dateWebPublish, !newValue);
                if (newValue) {
                    //this.dateWebPublish.setValue(new Date());
                    this.setAttributeValue("date_publish_in_web", new Date(), true);
                } else {
                    //this.dateWebPublish.setValue(null);
                    this.setAttributeValue("date_publish_in_web", null, true);
                }

                break;
        }
    }

    private setupTable() {
        this.weblinksTable = new StaticTable();
        this.weblinksTable.setLayout(this.tableLayout);

        this.weblinksTable.setupFromStore(this.weblinksStore);
        this.weblinksTable.setRowClick(lang.hitch(this, this._onRowClick));
        this.weblinksTable.addDefaultRowActionButton("edit", lang.hitch(this, this._onClickEdit));
        this.weblinksTable.addDefaultRowActionButton("delete");

        this.weblinksTable.placeAt(this.weblinksExpander);

        this.weblinksTable.setCyAttribute("marketingSectionsWeblinksTable");
    }

    private _onRowClick(row: StaticTable.StaticTableRow<HTWebfileLink>) {
        let entity = row.rowGroup.entity;

        this._openWeblinksEditor(entity, false);
    }

    private _onClickEdit(rowGroup: StaticTable.StaticTableRowGroup<HTWebfileLink>) {
        let entity = rowGroup.entity;

        this._openWeblinksEditor(entity, false);
    }

    private _openWeblinksEditor(entity: HTWebfileLink, isNew?: boolean) {
        let linkEditor = new WeblinksEditor();
        linkEditor.setup(entity.ref_webfile_link, entity.ID, isNew);

        linkEditor.on("confirmed", lang.hitch(this, this._onWeblinkEditorConfirm));
    }

    private _onWeblinkEditorConfirm(data: WeblinkEditorReponse) {
        let isNew: boolean = data.isNew;

        console.log(data);


        if (!isNew) {
            let weblink = this.weblinksStore.getEntityById(data.mainEntityId);
            weblink.ref_webfile_link = data.entity;
            this.weblinksStore.changeEntry(weblink, true);
        } else {
            let weblink: HTWebfileLink = {
                ID: data.mainEntityId,
                $Displayname: "",
                Classname: "",
                ClassPrintname: "",
                ref_webfile_link: data.entity
            }
            this.weblinksStore.addEntry(weblink);
        }
    }

    private _onChangeWeblinkStore(e) {
        let diffData = this.weblinksStore.getDiffData();
        this.setAttributeValue("weblinkDiffData", diffData);
    }

    private _onClickNew(e) {
        this.loadSelectEntityDialog(e, "createWeblink", lang.hitch(this._onSEDCallback));
    }

    protected onShow() {
    }

    private _onSEDCallback(mode: string, data: Array<string>, items: Array<SelectEntityDialogTypes.Item<WebfileLink | VtFile>>) {
        if (items && items.length > 0) {
            let treeName = items[0].sourceTree;
            let entity = items[0].entry.data;


            let newHTWebfileLink: HTWebfileLink

            switch (treeName) {
                case "appointment_weblinks":
                case "general_weblinks":
                    let webfileLink: WebfileLink = entity as WebfileLink;

                    newHTWebfileLink = {
                        ID: "" + Math.random() * 100000000,
                        $Displayname: "",
                        Classname: "",
                        ClassPrintname: "",
                        ref_webfile_link: webfileLink
                    }

                    if (this._storeHasWebfileLink(webfileLink)) {
                        this.showToast(this.translate("MarketingSection_Error_StoreHasWebfileLink"), "fas fa-exclamation-triangle");
                        return;
                    }

                    this._openWeblinksEditor(newHTWebfileLink, true);
                    break;
                case "files_of_projects":
                case "files_of_bookings":
                case "files_of_addresses":
                    let file: VtFile = entity as VtFile;

                    newHTWebfileLink = {
                        ID: "" + Math.random() * 100000000,
                        $Displayname: "",
                        Classname: "",
                        ClassPrintname: "",
                        ref_webfile_link: {
                            ID: "" + Math.random() * 100000000,
                            $Displayname: "",
                            Classname: "",
                            ClassPrintname: "",
                            description: "",
                            EL_ht_webfile_link_category_webfile_link: [],
                            ref_web_placement: null,
                            ref_main_ht_webfile_link_catergory: null,
                            ref_vt_files: file
                        }
                    }
                    //this._openWeblinksEditor(newHTWebfileLink, true);
                    this._openWeblinksOfFileDlg(file);
                    break;
            }
        }
    }

    hasData(): boolean {
        let hasContent = false;
        let currentData = this.getCurrentData();

        let keys = Object.keys(currentData);

        for (let key of keys) {
            switch (key) {
                case "ID":
                case "Classname":
                case "ClassPrintname":
                case "$Displayname":
                case "weblinkDiffData":
                case "EL_webfile_vt_appointment":
                    break;
                default:
                    if (currentData[key] && currentData[key].length > 0) return true;
            }
        }

        if (this.weblinksStore.getCurrentCompleteList().length > 0) return true;

        return hasContent;
    }

    private _openWeblinksOfFileDlg(file: VtFile) {
        let dlg = new FileWeblinksDlg();
        dlg.on("selected", lang.hitch(this, this._onWeblinkDlgSelect));
        dlg.open(file);
    }

    private _onWeblinkDlgSelect(entity: WebfileLink) {

        let newHTWebfileLink = {
            ID: "" + Math.random() * 100000000,
            $Displayname: "",
            Classname: "",
            ClassPrintname: "",
            ref_webfile_link: entity
        }

        if (this._storeHasWebfileLink(entity)) {
            this.showToast(this.translate("MarketingSection_Error_StoreHasWebfileLink"), "fas fa-exclamation-triangle");
            return;
        }

        this._openWeblinksEditor(newHTWebfileLink, true);
    }

    private _storeHasWebfileLink(webfileLink: WebfileLink): boolean {
        let completeList = this.weblinksStore.getCurrentCompleteList();

        for (let currentWebfileLink of completeList) {
            if (currentWebfileLink.ref_webfile_link.ID === webfileLink.ID) return true;
            if (
                currentWebfileLink.ref_webfile_link?.ref_vt_files?.ID === webfileLink.ref_vt_files.ID &&
                currentWebfileLink.ref_webfile_link?.ref_web_placement?.ID === webfileLink.ref_web_placement.ID
                ) {
                return true;
            }
        }

        return false;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.weblinksStore = new EntityStore();
        this.weblinksStore.on("change", lang.hitch(this, this._onChangeWeblinkStore));
        this.setupTable();

        this.SEDconfigCallfunction = "Webtool_API__EVBookingV2_Marketing_SED_GetConfig";

        this.addOnchanged("is_to_publish_in_web", lang.hitch(this, this.onChanged_IsToPublishInWeb))
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MarketingSection);